<style scoped>
    @import url("../../../styles/smartControl/dialogExec.scss");
</style>

<template>
    <div class="box_dialogExec">

        <!-- @input="handleDateChange"  -->
        <v-date-picker v-if="flagInitCalendar"
        v-model="selectedDate" 
        :allowed-dates="allowedDates"
        @update:modelValue="handleDateChange"
        />

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    props:['liDatas2conv2Date'],

    data() {
        return {

            // -- calendário v2.
            flagInitCalendar:false,
            selectedDate: null, // -- usado para reatividade com o componente calendar.
            dataFormatada:'', // -- valor final após processamento -> dd/mm/aaaa
            //allowedList: ['2025-06-24', '2025-06-25', '2025-06-26'],
            allowedList: [], // -- rcv via props.
        }
    },

    methods: {

        // -- CALENDARIO.
        allowedDates(date) {
            
            // Normaliza para string no formato YYYY-MM-DD
            const d = typeof date === 'string' ? date : date.toISOString().split('T')[0];
            return this.allowedList.includes(d);
        },
        handleDateChange(newDate) {

            if (!(newDate instanceof Date)) return;

            this.selectedDate = newDate

            const dia = String(newDate.getDate()).padStart(2, '0');
            const mes = String(newDate.getMonth() + 1).padStart(2, '0'); // +1 porque começa do zero
            const ano = newDate.getFullYear();

            const dataFormatada = `${dia}/${mes}/${ano}`;

            //console.log('Data selecionada (formatada):', dataFormatada);
            this.dataFormatada = dataFormatada; // agora é string "dd/mm/yyyy"
            this.$emit('fromDialog',this.dataFormatada) // desable dialog.
        },

        converterParaDateObj(data) {
            const [dia, mes, ano] = data.split('/');
            const d = new Date(Number(ano), Number(mes) - 1, Number(dia), 12, 0, 0); // horário seguro: 12h
            d.setDate(d.getDate() - 1);         // subtrair 1 dia (poderia ter subtraído na instrução acima)
            return d.toISOString().split('T')[0]; // → retorna '2025-05-24'
        }
    },

    created() {

        // -- montar formato correto para as datas.
        //console.log('this.allowedList: ',this.allowedList)
        if (this.liDatas2conv2Date.length > 0) {
            let c=0
            let isoDate = null
            while (c < this.liDatas2conv2Date.length) {
                
                isoDate = this.converterParaDateObj(this.liDatas2conv2Date[c])
                this.allowedList.push(isoDate)
                c++
            }
        }
        this.flagInitCalendar = true
        //console.log('this.allowedList: ',this.allowedList)

        // -- marcar valor inicial.
        //this.selectedDate = new Date(this.converterParaDateObj(this.liDatas2conv2Date[0]) + 'T12:00:00')

    }
}
</script>